import { render, staticRenderFns } from "./VendorModal.vue?vue&type=template&id=588f3dea&"
import script from "./VendorModal.vue?vue&type=script&lang=js&"
export * from "./VendorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588f3dea')) {
      api.createRecord('588f3dea', component.options)
    } else {
      api.reload('588f3dea', component.options)
    }
    module.hot.accept("./VendorModal.vue?vue&type=template&id=588f3dea&", function () {
      api.rerender('588f3dea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/fuel-resources/modals/VendorModal.vue"
export default component.exports